import { clsx } from 'clsx';
import styles from './HevoEntityMeta.module.scss';
import { HevoEntityMeta as HevoEntityMetaType } from '../../interfaces/entity-meta';
import { HEVO_ENTITY_META_DISPLAY_LABELS } from './constants';

export function HevoEntityMeta({
  meta,
  title,
  className
}: {
  meta: HevoEntityMetaType;
  title: string;
  className?: string;
}) {
  return (
    <div className={clsx('flex-col', className)} data-id='pipeline-meta'>
      <span className='text-medium text-subheading-2'>{title}</span>

      <div className='center-flex-row mt-2'>
        {Object.entries(meta).map(([key, value]) => (
          <div className={clsx('center-flex-row', styles.entityMetaField)} key={key}>
            <span className='text-secondary'>
              {HEVO_ENTITY_META_DISPLAY_LABELS[key as keyof HevoEntityMetaType]}:&nbsp;
            </span>
            <span className='text-medium'>{value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
